import React, { useState, useEffect, useContext, lazy, Suspense  } from 'react'
import { Link } from 'react-router-dom'
import { CountContext } from "../../App";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import NewMegaMenuEn from './Megamenu/menusEn';
import NewMegaMenuHi from './Megamenu/menusHi';
import ScrollButton from '../headerone/ScrollButton'
import GSearch from '../IITTP/GSearch'
import { LanguageContext } from '../../LanguageContext';

function Main() {
    const { theme, setTheme } = useContext(CountContext);

    const [Btnshow, setBtnshow] = useState(false);
    const [mobile, setmobile] = useState(false);
    const [Events, setEvent] = useState(false);
    const [News, setNews] = useState(false);
    const [Services, setServices] = useState(false);
    const [Blog, setblog] = useState(false);

    const [isScrolled, setIsScrolled] = useState(false);

    const [showNav, setShowNav] = useState(false);

    const toggleTheme = () => {
        if (theme === 'light') {
          setTheme('dark');
        } else {
          setTheme('light');
        }
      }

    const handleFontInc = () => {
        // get css variable value
        const root = getComputedStyle(document.documentElement);
        // console.log("CURRENT FONT SIZE: ", root.getPropertyValue('--base-font-size'))
        let oldpx = Number.parseInt(root.getPropertyValue('--base-font-size').replaceAll('px'));
        // set css variable value
        document.documentElement.style.setProperty(
            "--base-font-size",
            (oldpx + 1) + "px",
        )
    }

    const handleFontDec = () => {
        // get css variable value
        const root = getComputedStyle(document.documentElement);
        // console.log("CURRENT FONT SIZE: ", root.getPropertyValue('--base-font-size'))
        let oldpx = Number.parseInt(root.getPropertyValue('--base-font-size').replaceAll('px'));
        // set css variable value
        document.documentElement.style.setProperty(
            "--base-font-size",
            (oldpx - 1) + "px",
        )
    }
    
    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // -----------------------
    // *** Multilingual ***
    // -----------------------

    // const MenuEn = lazy(() => import('./Megamenu/menusHi'));
    // const MenuHi = lazy(() => import('./Megamenu/menusHi'));

    // const [lang, setLang ] = useState('en');
    const { language, setLanguage } = useContext(LanguageContext);
    // const [menuComponent, setMenuComponent] = useState(<MenuEn showNav={showNav} setShowNav={setShowNav} /> );

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        setShowNav(false);
        // setMenuComponent(lang === 'en' ? 
        //     <MenuEn showNav={showNav} setShowNav={setShowNav} />
        //     : 
        //     <MenuHi showNav={showNav} setShowNav={setShowNav} />
        // );
    };

    return (
        <>
            <header className="header-area header-three">
                <div className="header-top second-header d-md-block">
                    <div className="container">
                        {/* <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 d-none d-lg-block ">
                                <div className="header-social">
                                    <span>
                                        <Link to="https://www.facebook.com/iittp" target='_blank' title="Facebook">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                        <Link to="https://in.linkedin.com/school/iittirupati" target='_blank' title="LinkedIn">
                                            <i className="fab fa-linkedin" />
                                        </Link>
                                        <Link to="https://twitter.com/iit_tirupati" target='_blank' title="Twitter">
                                            <img width={16} src='assets/img/logo/x-twitter.svg' alt='Twitter Logo' />
                                        </Link>
                                        <Link to="https://www.youtube.com/c/IITTirupatiofficial" target='_blank' title="Youtube">
                                            <i className="fab fa-youtube" />
                                        </Link>
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 d-none d-lg-block ">
                                <div className="header-cta">
                                    <ul>
                                        <li>
                                            <Link to="/directory" title="Directory">
                                                <i className="fas fa-folder-open"></i>Directory
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/tenders" title="Tenders">
                                                <i className="fas fa-bullhorn"></i>Tenders 
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" title="ERP Workflow">
                                            <i className="fas fa-briefcase"></i>
                                                ERP
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/recruitment" title="Recruitment">
                                                <i className="fas fa-folder-open"></i>Career 
                                            </Link>
                                        </li>

                                    </ul>

                                  
                                </div>
                            </div>
                            <div className='col-lg-5 col-md-5 d-none d-lg-block text-right'>
                                <div className="row">
                                    <div className="col-2">
                                        <div className="header-cta">
                                            <ul>
                                                <li>
                                                    <Link to="#" title="Increase Font Size" onClick={handleFontInc}>
                                                    <>A+</>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="Decrease Font Size" onClick={handleFontDec}>
                                                    <>A-</>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="header-cta">
                                            <ul>
                                                <li>
                                                    <Link to="#" title="English">
                                                        <>Eng</>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="Hindi" style={{verticalAlign:"middle"}}>
                                                        <>हिंदी</>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="Telugu" style={{verticalAlign:"middle"}}>
                                                        <>తెలుగు</>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="header-cta" >
                                            <ul>
                                                <li>
                                                    <Link to="#" title="Screen Reader">
                                                        <i className="fas fa-universal-access" style={{fontSize:"1.25em"}}></i>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="Light/Dark Theme" onClick={toggleTheme}>
                                                        <i className="fas fa-eclipse-alt" style={{fontSize:"1.2rem"}} ></i>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="Search">
                                                        <i className="fal fa-search fw" onClick={() => { setBtnshow(true) }} />
                                                    </Link>
                                                </li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            
                            
                        </div> */}
                            <div className='d-flex justify-content-between'>
                                <div className="header-social d-none d-md-block ">
                                    <span>
                                        <Link to="https://www.facebook.com/iittp" target='_blank' title="Facebook">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                        <Link to="https://in.linkedin.com/school/iittirupati" target='_blank' title="LinkedIn">
                                            <i className="fab fa-linkedin" />
                                        </Link>
                                        <Link to="https://twitter.com/iit_tirupati" target='_blank' title="Twitter">
                                            <img width={16} src='assets/img/logo/x-twitter.svg' alt='Twitter Logo' />
                                        </Link>
                                        <Link to="https://www.youtube.com/c/IITTirupatiofficial" target='_blank' title="Youtube">
                                            <i className="fab fa-youtube" />
                                        </Link>
                                    </span>
                                </div>
                            
                                <div className="header-cta">
                                    <ul>
                                        <li className='d-none d-sm-inline'>
                                            <Link to="https://iittp.ac.in/TD" target='_blank' title="Directory">
                                                <i className="fas fa-folder-open"></i>{language === 'en' ? 'Directory' : 'निर्देशिका'}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/tenders" title="Tenders">
                                                <i className="fas fa-bullhorn"></i>{language === 'en' ? 'Tenders' : 'निविदाएं'} 
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target='_blank' title="ERP Workflow">
                                            <i className="fas fa-briefcase"></i>{language === 'en' ? 'ERP' : 'ईआरपी'} 
                                            </Link>
                                        </li>
                                        {/* <li>
                                            <Link to="/recruitment" title="Careers">
                                                <i className="fas fa-folder-open"></i>{language === 'en' ? 'Careers' : 'कैरियर'} 
                                            </Link>
                                        </li> */}
                                        <li className='d-none d-sm-inline' style={{whiteSpace:'nowrap'}}>
                                            <Link to="https://library.iittp.ac.in/" target='_blank' title="Central Library">
                                                <i className="fas fa-books"></i>{language === 'en' ? 'Central Library' : 'केन्द्रीय पुस्तकालय'} 
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                                            
                                <div className="header-cta">
                                    <ul>
                                        <li>
                                            <Link to="#" title="Increase Font Size" onClick={handleFontInc}>
                                            <>A+</>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="Decrease Font Size" onClick={handleFontDec}>
                                            <>A-</>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            
                                <div className="header-cta">
                                    <ul>
                                        {language==='hi' && (
                                            <li>
                                                <Link to="#" title="Switch to English" onClick={() => handleLanguageChange('en')}>
                                                    <>English</>
                                                </Link>
                                            </li>    
                                        )}
                                        {language==='en' && (
                                            <li>
                                                <Link to="#" title="Switch to Hindi" style={{verticalAlign:"middle"}} onClick={() => handleLanguageChange('hi')}>
                                                    <>हिंदी</>
                                                </Link>
                                            </li>    
                                        )}
                                        
                                        
                                        {/* <li>
                                            <Link to="#" title="Telugu" style={{verticalAlign:"middle"}}>
                                                <>తెలుగు</>
                                            </Link>
                                        </li> */}
                                    </ul>
                                </div>
                            {/* )} */}
                                
                            
                            
                                <div className="header-cta" >
                                    <ul>
                                        <li className='d-none'>
                                            <Link to="#" title="Screen Reader">
                                                <i className="fas fa-universal-access" style={{fontSize:"1.25em"}}></i>
                                            </Link>
                                        </li>
                                        <li className='d-none'>
                                            <Link to="#" title="Light/Dark Theme" onClick={toggleTheme}>
                                                <i className="fas fa-eclipse-alt" style={{fontSize:"1.2rem"}} ></i>
                                            </Link>
                                        </li>
                                        
                                        <li className="d-inline d-sm-none">
                                            <Link to="https://gac.iittp.ac.in/giving-back" title="Give to IIT Tirupati" >
                                                <i className="fas fa-handshake" />
                                                {/* <i className="fas fa-hand-holding-heart" /> */}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="Search">
                                            
                                                <i className="fal fa-search fw" onClick={() => { setBtnshow(true) }} />
                                            </Link>
                                        </li>
                                        
                                    </ul>
                                </div>
                            
                            </div>

                    </div>
                </div>
                <div id="header-sticky" className={`menu-area${isScrolled ? ' menu-area sticky-menu' : ''}`}>
                    <div className="container ">
                        {/* <div className="second-menu" style={{flexDirection: showNav ? 'column' : 'row'}}> */}
                        <div className={`second-menu ${showNav ? '' : 'collapse'}`}>
                                <div className="section-logo" >
                                    <div className="logo ">
                                        
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 0, hide: 1000 }}
                                                overlay={<Tooltip><Link to="/aboutlogo" className='text-white'>About Logo</Link></Tooltip>}
                                                >
                                                <Link to="/">
                                                    <img width={85} src="assets/img/logo/logo.svg" alt="logo" />
                                                </Link>
                                            </OverlayTrigger>
                                        
                                    </div>
                                    <div className="logo2">
                                        <div className="logo-text-hindi">
                                            <span>భారతీయ </span> 
                                            <span>సాంకేతిక </span> 
                                            <span>విజ్ఞాన </span>
                                            <span>సంస్థ </span>
                                            <span>తిరుపతి</span>
                                        </div>
                                        <div className="logo-text-hindi">
                                            <span>भारतीय </span> 
                                            <span>प्रौद्योगिकी </span>
                                            <span>संस्थान </span>
                                            <span>तिरुपति </span>
                                        </div>
                                        <div className="logo-text">
                                            <span>INDIAN </span>
                                            <span>INSTITUTE </span>
                                            <span>OF </span> 
                                            <span>TECHNOLOGY </span> 
                                            <span>TIRUPATI </span>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                                
                                <div className="dd-main-menu">
                                    <Suspense fallback={<div>Loading...</div>}>
                                        {/* {menuComponent} */}
                                        {
                                            language === 'en' ? 
                                                    <NewMegaMenuEn showNav={showNav} setShowNav={setShowNav} />
                                                    : 
                                                    <NewMegaMenuHi showNav={showNav} setShowNav={setShowNav} />
                                                
                                        }
                                        {/* <NewMegaMenu showNav={showNav} setShowNav={setShowNav} /> */}
                                    </Suspense>
                                    
        
                                </div>
                        </div>
                    </div>
                </div>
            </header>

            {Btnshow &&
                <>
                    <div className={`scrollbar scrollbar1 offcanvas-menu ${"active"}`}>
                        <span className="menu-close" onClick={() => setBtnshow(false)}>
                            <i className="fas fa-times" onClick={() => setBtnshow(false)} />
                        </span>
                        
                        <GSearch />


                    </div>
                    <div className={`offcanvas-overly ${"active"}`}> </div>
                </>
            }
            <ScrollButton/>
        </>
    )
}

export default Main;